import React, { useState, useEffect } from 'react'
import { Container, Col, Modal, Button, Form, Row } from 'react-bootstrap';
import { CustomTextField } from '../../../../../shared/customTextField';
import { CustomButton } from '../../../../../shared/customButton';
import { CustomTextArea } from '../../../../../shared/customTextArea';


import * as yup from 'yup';
import { Formik } from 'formik';
import styles from './meetingConfiguration.module.scss';

const InterviewConfiguration = (props) => {
    let [isTicketCreationPending, setIsTicketCreationPending] = useState(false);

    const onSubmit = (values) => {
        props.nextPage(2);
        props.setSubmitValues(values);
    }

    const schema = yup.object({
        externalMeetingURL:yup.string().matches(/^(http|https):\/\/[^ "]+$/, 'Invalid URL. Must start with  http://, or https://').required('URL is required'),
        description: yup.string().trim().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^').max(800, 'Character length should be less than 800')
    });

    return (
        <div>
            <Formik
                validationSchema={schema}
                onSubmit={(values) => onSubmit(values)}
                initialValues={{ externalMeetingURL: props.values.externalMeetingURL, description: props.values.description }}>

                {({
                    values,
                    errors,
                    handleChange,
                    handleSubmit,
                    submitCount
                }) => (
                    <Form noValidate onSubmit={handleSubmit}>

                        <Row>

                            <Col className={styles.pipelineConfigurationsCol}>
                                <CustomTextArea
                                    label="External Meeting URL"
                                    classLabel="defaultLabel"
                                    controlId="externalMeetingURL"
                                    placeholder="Ex: Zoom, Microsoft Teams ,etc"
                                    type="text"
                                    values={values.externalMeetingURL}
                                    name="externalMeetingURL"
                                    classType="defaultTextBox"
                                    handleChange={handleChange}
                                    errorMessage={errors.externalMeetingURL}
                                    isInvalid={submitCount > 0 && !!errors.externalMeetingURL}
                                />

                            </Col>
                        </Row>
                        <Row className='mt-2'>
                            <Col sm={12} className={styles.pipelineConfigurationsCol}>
                                <CustomTextArea
                                    label="Description (optional)"
                                    name="description"
                                    values={values.description}
                                    errorMessage={errors.description}
                                    handleChange={handleChange}
                                    isInvalid={submitCount > 0 && !!errors.description}
                                    remainingCount={(values.description).length}
                                    maxLength={800}
                                />
                            </Col>
                        </Row>

                        <Row className="mt-3 mb-5">
                            <Col>
                                <CustomButton
                                    buttonType="submit"
                                    label="Review"
                                    type="primaryBtn"
                                // backicon={isTicketCreationPending ? <i className="fas fa-circle-notch fa-spin" aria-hidden="true"></i> : null}
                                // disabled={isTicketCreationPending ? true : false}
                                />
                            </Col>
                        </Row>
                    </Form>
                )}
            </Formik>





        </div>
    )
}

export default InterviewConfiguration